import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08607330"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "ant-row ss-div-corpo-titulo-card" }
const _hoisted_3 = {
  key: 0,
  class: "ant-col ant-col-xl-3 ant-col-xs-3"
}
const _hoisted_4 = {
  class: "ant-col'",
  style: {"flex":"auto 1 1"}
}
const _hoisted_5 = { class: "ss-div-titulo-card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ações", -1))
const _hoisted_7 = {
  class: "ant-btn ss-botao ss-botao-menu",
  style: {"margin-top":"-8px"}
}
const _hoisted_8 = { class: "ant-row ss-div-detalhe-card" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24",
  style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_11 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.props.card.identificador,
    class: "ss-div-corpo-card ss-sombra-suave ss-mover",
    style: _normalizeStyle('border-left-color: ' + _ctx.props.cor + ';'),
    onMouseenter: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selecaoCardAlterada && _ctx.selecaoCardAlterada(...args)))
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.props.selecionavel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_a_tooltip, {
              placement: "top",
              title: "Selecionar"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_checkbox, {
                  class: "ss-checkbox-selecionar",
                  checked: _ctx.computedCard.selecionado,
                  "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedCard.selecionado) = $event)),
                  onChange: _ctx.clickSelecionar
                }, null, 8, ["checked", "onChange"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickVisualizar && _ctx.clickVisualizar(...args)))
          }, _toDisplayString(_ctx.props.card.titulo), 1)
        ])
      ]),
      _createElementVNode("div", {
        "on:mouseEnter": _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickSubMenu && _ctx.clickSubMenu(...args))),
        class: "ant-col ant-col-xl-3 ant-col-xs-3"
      }, [
        _createVNode(_component_a_dropdown, null, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "menus", {}, undefined, true)
              ]),
              _: 3
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_tooltip, { placement: "top" }, {
              title: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_7, [
                  _createVNode(_component_icone, {
                    style: {"font-size":"12px"},
                    nome: "menu-pontos"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 3
        })
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.card.detalhes, (detalhe, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "ant-row"
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, [
                _createElementVNode("b", null, _toDisplayString(detalhe.titulo), 1)
              ]),
              _createTextVNode("  "),
              _createElementVNode("span", {
                title: detalhe.detalhe
              }, _toDisplayString(detalhe.detalhe), 9, _hoisted_11)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 44, _hoisted_1))
}